import { Component, OnInit } from '@angular/core';

declare var google: any;

@Component({
  selector: 'app-wifi-detectors',
  templateUrl: './wifi-detectors.component.html',
  styleUrls: ['./wifi-detectors.component.css']
})
export class WifiDetectorsComponent implements OnInit {

  ngOnInit() {
    google.charts.load('current', { packages: ['corechart'] });
    google.charts.setOnLoadCallback(this.drawChart);
  }

  drawChart() {
    const data = new google.visualization.DataTable();
    data.addColumn('string', 'Versions');
    data.addColumn('number', 'Number of Devices');
    data.addRows([
      ['version 3.2', 19745],
      ['version 3.0', 5432],
      ['version 2.9', 1777],
      ['version 2.3', 654],
      ['version 2.7', 17]
    ]);

    const options = {
      title: 'Kidde Version App Insight',
      width: 400,
      height: 400,
      is3D: true
    };

    const chart = new google.visualization.PieChart(document.getElementById('chart_div'));
    chart.draw(data, options);
  }
}
